
import ajaxAdmin from '../frontend/ajax-admin.js';
import React from 'react';
import {css} from 'emotion';
import {FormEdit} from '../frontend/helpers/FormEdit/FormEdit.jsx';
import {useEffect} from 'react';
import {useFirstRender} from '../utilities/React.js';
import {useStateAtom} from '../utilities/React/UseStateAtom.js';
import {wrapStateAtom} from '../libs/reactjs/wrapStateAtom.js';
import {yamlParse} from '../utilities/yaml/yamlParse.js';
import {yamlStringify} from '../utilities/yaml/yamlStringify.js';

export default function (props) {

  const formInfo = useStateAtom(null);
  const nameSource = useStateAtom('');
  const definitionASTSource = useStateAtom('');
  const definitionAST = useStateAtom(null);

  useFirstRender(async () => {
    formInfo((await ajaxAdmin.adminFormLoad(props.formId)).form);
    nameSource(formInfo().name);
    definitionAST({pages: [], ...yamlParse(formInfo().definitionScript)});
    definitionASTSource(yamlStringify(definitionAST()));
  });

  return (<>

    {definitionAST() && (<>

      <div
        className={css`
          display: flex;
          width: 100%;
          gap: 16px;
          padding: 0 16px;
        `}
      >
        <div
          className={css`
            flex: none;
          `}
        >
          Form name:
        </div>
        <div
          className={css`
            flex: 1 1 0%;
          `}
        >
          <input
            type="text"
            className={css`
              width: 100%;
            `}
            value={formInfo().name}
            onChange={(e) => {
              formInfo({...formInfo(), name: e.target.value});
            }}
          />
        </div>
      </div>

      <div
        className={css`
          margin-top: 16px;
          position: relative;
          height: calc(100vh - 230px);
          overflow: auto;
        `}
      >
        <FormEdit
          definitionAST={definitionAST}
        />
      </div>

      <div
      className={css`
        text-align: right;
        padding: 8px;
      `}
      >
        <button
          className={css`
            padding: 4px;
          `}
          onClick={async (e) => {
            await ajaxAdmin.adminFormUpdate(props.formId, {
              name: formInfo().name,
              definitionScript: yamlStringify(definitionAST()),
            });
            nameSource(formInfo().name);
            definitionASTSource(yamlStringify(definitionAST()));
          }}
        >
          {nameSource() != formInfo().name || definitionASTSource() != yamlStringify(definitionAST()) ? 'Save' : 'Saved'}
        </button>
      </div>

    </>)}

  </>);

};
